import styled from '@emotion/styled';
import { Button } from 'antd';

export const StatusUpdateButton = styled(Button)`
  color: #ffffff;
  background: ${props => (props.type === 'accept' ? '#52c41a' : '#f5222d')};
  border-color: ${props => (props.type === 'accept' ? '#52c41a' : '#f5222d')};
`;
